<template>
  <div class="newsletter__form__input newsletter__form__input_mail">
    <label :for="name" class="newsletter__form__label">
      <slot></slot>
    </label>
    <input
      type="email"
      required="required"
      autocomplete="email"

      @invalid="showInputError"
      @input="hideInputError"

      :name="name"
      :id="name"
      :placeholder="placeholder"

      v-model="email" />
    <span class="newsletter__form__validation newsletter__form__validation_mail" v-if="inputErrorVisible">{{ inputErrorText }}</span>
  </div>
</template>

<script>
export default {
  name: 'EmailInput',
  props: {
    name: {
      type: String
    },
    placeholder: {
      type: String
    },
    inputError: {
      type: Object
    }
  },
  data() {
    return {
      email: '',
      inputErrorVisible: false,
      inputErrorText: ''
    }
  },
  methods: {
    getFormData() {
      let data = {}

      data[this.name] = this.email

      return data
    },
    showInputError(event) {
      event.preventDefault()

      this.inputErrorVisible = true
      this.inputErrorText = this.inputError.valueMissing

      if ('validity' in event.target && event.target.validity.typeMismatch) {
        this.inputErrorText = this.inputError.typeMismatch
      }
    },
    hideInputError() {
      this.inputErrorVisible = false
    }
  }
}


</script>


// WEBPACK FOOTER //
// EmailInput.vue?526b6064